import InvitationApi from '@/api/invitation'
import accountApi from '@/api/account'

const actions = {
  createInvitationsAction: async ({ rootGetters }, payload) => {
    const extraParams = {}
    if (rootGetters['multipleSessions/canLimitInviteSent']) {
      extraParams.limitedAddInvitations = true
    }
    extraParams.v = 2
    if (rootGetters['featureToggles/canReplyToSender']) {
      extraParams.enableSenderReplyTo = true
    }
    return InvitationApi.createInvitations(payload, extraParams)
  },

  createAccountAction: async (_, payload) => {
    const extraParams = { v: 2 }
    return accountApi.createAccount(payload, extraParams)
  },

  // AHA-46165: rename the caller's own team, then keep the root currentAccount
  // in sync so every display site (sidebar, workspace switcher, breadcrumb)
  // reflects the new name at once. Lets the API error propagate so the caller
  // can surface it.
  updateAccountAction: async ({ dispatch, rootState }, name) => {
    await accountApi.updateAccount({ name })
    await dispatch(
      'setCurrentAccountAction',
      { ...rootState.currentAccount, name },
      { root: true },
    )
  },
}

export default actions
